import { TextButton } from '@creditornot/cb-button';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type ToastErrorListProps = {
  optionsWithErrors: { optionName: string; errorMessage?: string }[];
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const ShowDetailsButton = styled(TextButton)`
  margin-block-start: 8px;
`;

const ErrorList = styled.div`
  width: 100%;
  margin-block-start: 12px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 300px;
`;
const OptionError = styled.div`
  display: flex;
  flex-direction: column;
  margin-block-end: 4px;
`;

const OptionName = styled(T.Body3)`
  font-weight: bold;
`;

export const ToastErrorList = ({ optionsWithErrors }: ToastErrorListProps) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Root>
      <FormattedMessage id="listing-manager.offer-options.error.message" />
      <ShowDetailsButton onClick={() => setShowDetails(!showDetails)}>
        <FormattedMessage id={showDetails ? 'errors.hideErrorDetails' : 'errors.showErrorDetails'} />
      </ShowDetailsButton>
      {showDetails && (
        <ErrorList>
          {optionsWithErrors.map((optionWithError, index) => {
            return (
              <OptionError key={index}>
                <OptionName>{optionWithError.optionName}:</OptionName>
                <T.Body3>
                  •{' '}
                  {!!optionWithError.errorMessage ? (
                    optionWithError.errorMessage
                  ) : (
                    <FormattedMessage id="errors.unknown-error-occurred" />
                  )}
                </T.Body3>
              </OptionError>
            );
          })}
        </ErrorList>
      )}
    </Root>
  );
};
